import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyAIStandardBanner: FunctionComponent = () => {
  const AIStandardBanner = useLazyComponent(
    () =>
      import(/* webpackChunkName: "ai-standard-banner" */ './AIStandardBanner'),
    { namedImport: 'AIStandardBanner', preload: false },
  );
  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        <AIStandardBanner />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
